import { render, staticRenderFns } from "./aufgabe-details-modal.vue?vue&type=template&id=5370fb62&scoped=true"
import script from "./aufgabe-details-modal.vue?vue&type=script&lang=js"
export * from "./aufgabe-details-modal.vue?vue&type=script&lang=js"
import style0 from "./aufgabe-details-modal.vue?vue&type=style&index=0&id=5370fb62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5370fb62",
  null
  
)

export default component.exports